import { AdMediaCarousel } from "components/domains/ads"
import { useSponsoredScreensaver } from "hooks/sponsored-content/useSponsoredScreensaver"

export const SponsoredContentScreenSaverPlayer = () => {
  const { screensaverConfig, screensavers } = useSponsoredScreensaver()

  return (
    <AdMediaCarousel
      data={screensavers ?? []}
      carouselOptions={{
        autoplay: screensaverConfig?.autoplay ?? true,
        interval: screensaverConfig?.interval ?? 5,
      }}
      componentName="HomeSceenSaver"
      width={1000}
      height={1250}
    />
  )
}
